<template>
  <div>
    <vue-element-loading
      :active="appLoading"
      :is-full-screen="true"
      background-color="#FFFFFF"
      color="#FDAC53"
      spinner="bar-fade-scale"
    />
    <v-snackbar v-model="snackbar" color="#FEBD08" right :timeout="timeout">
      <v-layout wrap>
        <v-flex text-left class="align-self-center">{{ msg }}</v-flex>
        <v-flex text-right>
          <v-btn small :ripple="false" text @click="snackbar = false">
            <v-icon style="color: white">mdi-close</v-icon>
          </v-btn>
        </v-flex>
      </v-layout>
    </v-snackbar>
    <v-layout
      wrap
      justify-center
      style="background-color: #fafafa"
      py-8
      py-lg-12
    >
      <v-flex xs10>
        <v-layout wrap px-lg-12 justify-center>
          <v-flex
            xs12
            text-center
            py-3
            style="font-family: robotoregular; font-size: 25px"
          >
            CUSTOMER REVIEWS
          </v-flex>
          <v-flex xs6 text-center pb-3>
            <v-layout wrap justify-center>
              <v-flex xs12 md3 lg2>
                <v-rating
                  :value="parseFloat(rev.rating)"
                  color="amber"
                  background-color="#C7BCBC"
                  half-increments
                  length="5"
                  readonly
                  size="13"
                ></v-rating>
              </v-flex>
              <v-flex pl-lg-12 xs6 md4 pl-md-10 lg3 align-self-center>
                <span>{{ rev.totalReviews }} Reviews</span>
              </v-flex>
            </v-layout>
          </v-flex>
          <v-flex xs12 pb-5 text-center v-if="storage.isPurchased==true">
            <v-dialog v-model="dialog" max-width="700px">
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  tile
                  v-bind="attrs"
                  v-on="on"
                  width="20%"
                  :style="
                    $vuetify.breakpoint.name == 'xs'
                      ? 'width:100%;background-color:black;color:white'
                      : $vuetify.breakpoint.name == 'sm'
                      ? 'width:50%;background-color:black;color:white'
                      : (style = 'width:20%;background-color:black;color:white')
                  "
                  >write a review</v-btn
                >
              </template>
              <v-card>
                <v-card-text>
                  <v-layout justify-start wrap pt-5>
                    <v-flex xs12 sm12 md12 pa-2>
                      <v-textarea
                        v-model="review"
                        class="text"
                        label="Comment"
                        outlined
                        dense
                      ></v-textarea>
                    </v-flex>
                    <v-flex xs12 sm12 md12 pa-2>
                      <v-rating
                        v-model="rating"
                        :value="parseFloat(rating)"
                        color="amber"
                        background-color="#C7BCBC"
                        half-increments
                        large
                      ></v-rating>
                    </v-flex>
                  </v-layout>
                </v-card-text>
                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-layout justify-center wrap>
                    <v-flex xs6 sm4 px-2>
                      <v-btn
                        block
                        tile
                        color="#757575"
                        outlined
                        :ripple="false"
                        depressed
                        @click="dialog = false"
                      >
                        Close
                      </v-btn>
                    </v-flex>
                    <v-flex xs6 sm4 px-2>
                      <v-btn
                        tile
                        block
                        dark
                        color="#FF1313"
                        depressed
                        class="text-capitalize"
                        :ripple="false"
                        @click="reviewadd()"
                      >
                        Save
                      </v-btn>
                    </v-flex>
                  </v-layout>
                </v-card-actions>
              </v-card>
            </v-dialog>
          </v-flex>
          <v-flex xs12>
            <v-layout wrap justify-start v-if="reviews.length > 0">
              <v-flex
                pb-5
                md6
                px-lg-5
                v-for="(item, i) in reviews"
                :key="i"
                pt-lg-12
              >
                <v-card flat style="background-color: #fafafa">
                  <v-layout wrap>
                    <v-flex xs2 text-center v-if="item.uid.photo">
                      <v-avatar size="60">
                        <v-img :src="mediaURL + item.uid.photo" />
                      </v-avatar>
                    </v-flex>
                    <v-flex xs2 v-else text-center>
                      <v-avatar size="60"
                        ><v-img src="../../assets/images/nouser.png" />
                      </v-avatar>
                    </v-flex>
                    <v-flex xs9 pl-3 pl-md-0>
                      <v-layout wrap>
                        <v-flex
                          xs12
                          v-if="item.uid"
                          style="font-family: robotobold"
                          >{{ item.uid.firstname }} {{ item.uid.lastname }}
                        </v-flex>
                        <v-flex xs12>
                          <v-rating
                            :value="parseFloat(item.rating)"
                            color="amber"
                            background-color="#C7BCBC"
                            half-increments
                            length="5"
                            readonly
                            size="15"
                          ></v-rating>
                        </v-flex>
                        <v-flex xs12 class="text">
                          {{ item.review }}
                        </v-flex>
                      </v-layout>

                      <!-- <div style="font-family:robotobold">peter antony</div>
                    <div >
                      <v-rating
                        :value="4"
                        color="amber"
                        half-increments
                        length="5"
                        readonly
                        size="15"
                      ></v-rating>
                    </div>
                    <div class="text">
                      Lorem Ipsum is simply dummy text of the printing and
                      typesetting industry. Lorem Ipsum has been the industry’s
                      standard dummy text ever since the 1500s,
                    </div> -->
                    </v-flex>
                  </v-layout>
                </v-card>
              </v-flex>
              <v-flex v-if="reviews.length > 4" xs12 text-center>
                <v-btn outlined width="30%" tile> View ALL</v-btn>
              </v-flex>
            </v-layout>
          </v-flex>
        </v-layout>
      </v-flex>
    </v-layout>
  </div>
</template>
<script>
import axios from "axios";
export default {
  props: ["id", "storage"],
  data() {
    return {
      rating: 4.5,
      review: "",
      dialog: false,
      snackbar: false,
      appLoading: false,
      reviews: [],
      rev: [],
      myRev: [],
      msg: "",
      timeout: 5000,
    };
  },
  mounted() {
    this.getData();
    this.myReview();
  },
  methods: {
    getData() {
      this.appLoading = true;
      var data = {};
      data["ratingType"] = "seller";
      data["sellerId"] = this.id;
      axios({
        method: "POST",
        url: "/rating/list",
        data: data,
      }).then((response) => {
        this.appLoading = false;
        if (response.data.status) {
          this.reviews = response.data.data;
          this.rev = response.data;
        } else {
          console.log("no data ");
        }
      });
    },
    myReview() {
      this.appLoading = true;
      var data = {};
      data["ratingType"] = "seller";
      data["sellerId"] = this.id;
      axios({
        method: "POST",
        url: "/my/rating/view",
        data: data,
        headers: {
          "x-auth-token": localStorage.getItem("token"),
        },
      }).then((response) => {
        this.appLoading = false;
        if (response.data.status) {
          this.myRev = response.data.data;
          this.review = this.myRev.review;
          this.rating = this.myRev.rating;
          // this.rev=response.data
        } else {
          console.log("no data ");
        }
      });
    },
    reviewadd() {
      var data = {};
      data["review"] = this.review;
      data["ratingType"] = "seller";
      data["rating"] = this.rating;
      data["sellerId"] = this.id;
      axios({
        url: "/rating/add/update",
        method: "POST",
        data: data,
        headers: {
          "x-auth-token": localStorage.getItem("token"),
        },
      })
        .then((response) => {
          this.appLoading = false;
          if (response.data.status) {
            this.dialog = false;
            this.msg = "Added Sucessfully";
            this.snackbar = true;
            this.getData();
            // this.review = null;
          } else {
            this.msg = response.data.msg;
            this.snackbar = true;
          }
        })
        .catch((err) => {
          this.appLoading = false;
          this.ServerError = true;
          console.log(err);
        });
    },
  },
};
</script>